var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnTutorial = function SvgIcnTutorial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4439_11480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0Z",
    fill: "#753BBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.262 8.25167L21.7501 13.7398C21.8275 13.8171 21.8275 13.9362 21.7501 14.0136L20.2084 15.5552C20.131 15.6326 20.012 15.6326 19.9346 15.5552L14.4465 10.0672C14.3691 9.98977 14.3691 9.87072 14.4465 9.79334L15.9882 8.25167C16.0655 8.17429 16.1846 8.17429 16.262 8.25167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0774 5.15458L24.8452 10.9224L21.2797 13.2617L16.7381 8.72005L19.0774 5.15458Z",
    fill: "#2B3B4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09533 23.2158L10.1668 19.1443C9.78581 18.4658 9.887 17.5848 10.4644 17.0074C11.1608 16.311 12.2977 16.311 13.0001 17.0074C13.6965 17.7039 13.6965 18.8408 13.0001 19.5432C12.4227 20.1205 11.5477 20.2217 10.8632 19.8408L6.79771 23.9062L18.2263 21.2872L19.6191 15.2158L14.7977 10.3943L8.72628 11.7872L6.09533 23.2158Z",
    fill: "#F7D95B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4439_11480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(30 30) rotate(-180)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnTutorial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_tutorial.7bf7f4ac.svg";
export { ForwardRef as ReactComponent };